exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nsvg[data-v-1dbbbeea] {\n  margin-right: 1%;\n}\nbutton[data-v-1dbbbeea] {\n  text-align: center;\n}\n.card-header[data-v-1dbbbeea] {\n  z-index: 2;\n  opacity: 1;\n  background-color: #f7f7f7;\n  white-space: nowrap;\n}\n", ""]);
